import request from '@/utils/request'
import axios from 'axios'


// 圖片轉Excel - 返回文件路径（简化版）
export function imageToExcel(file, threshold = 50) {
  const formData = new FormData()
  formData.append('file', file)

  // 直接使用传入的整数值（例如：50）
  return request({
    url: `/infer/image-to-excel-sheets/${threshold}`,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 下载Excel文件并返回blob
export function downloadExcelFile(excelUrl) {
  console.log('Downloading Excel file from:', excelUrl)

  if (process.env.NODE_ENV === 'development') {
    // 开发环境：使用代理路径
    // excelUrl 格式: /profile/upload/xxx.xlsx
    // 代理会将其转换为: http://greenai.website:63335/api/profile/upload/xxx.xlsx
    return axios({
      url: excelUrl,
      method: 'get',
      responseType: 'blob',
      timeout: 30000,
      headers: {
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    }).then(response => {
      console.log('Download response:', response.status, response.headers['content-type'])
      return response.data
    }).catch(error => {
      console.error('Download error:', error.response?.status, error.response?.data)
      throw error
    })
  } else {
    // 生产环境：使用完整URL
    const fullUrl = `https://demo-table.buzigai.com/api${excelUrl}`
    console.log('Production download URL:', fullUrl)

    return axios({
      url: fullUrl,
      method: 'get',
      responseType: 'blob',
      timeout: 30000,
      headers: {
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    }).then(response => response.data)
  }
}

// 通用文件下载方法
export function downloadFile(fileUrl, filename) {
  console.log('Downloading file from:', fileUrl)

  if (process.env.NODE_ENV === 'development') {
    // 开发环境：使用代理路径
    return axios({
      url: fileUrl,
      method: 'get',
      responseType: 'blob',
      timeout: 30000
    }).then(response => {
      console.log('Download response:', response.status, response.headers['content-type'])

      // 创建下载链接
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)

      return response.data
    }).catch(error => {
      console.error('Download error:', error.response?.status, error.response?.data)
      throw error
    })
  } else {
    // 生产环境：使用完整URL
    const fullUrl = `https://demo-table.buzigai.com/api${fileUrl}`
    console.log('Production download URL:', fullUrl)

    return axios({
      url: fullUrl,
      method: 'get',
      responseType: 'blob',
      timeout: 30000
    }).then(response => {
      // 创建下载链接
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)

      return response.data
    })
  }
}